import { useState } from "react";
import { Link, useNavigate, Navigate } from "react-router-dom";
import { toast } from "sonner";
import { Clapperboard, Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { useAuth } from "@/context/AuthContext";

function formatApiErrorDetail(detail) {
  if (detail == null) return "Terjadi kesalahan. Silakan coba lagi.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : "")).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return "Terjadi kesalahan. Silakan coba lagi.";
}

export default function Login() {
  const { user, login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  if (user) return <Navigate to="/dashboard" replace />;

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email.trim(), password);
      toast.success("Berhasil masuk");
      navigate("/dashboard");
    } catch (err) {
      toast.error(formatApiErrorDetail(err?.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen grid lg:grid-cols-2 bg-slate-50">
      <div className="hidden lg:flex flex-col justify-between bg-blue-600 p-12 text-white">
        <div className="flex items-center gap-3">
          <div className="flex h-10 w-10 items-center justify-center rounded-xl bg-white/15">
            <Clapperboard className="h-5 w-5" />
          </div>
          <div>
            <p className="font-heading font-bold leading-tight">Mas Tofa AI</p>
            <p className="text-xs text-blue-100">AI Video Generator</p>
          </div>
        </div>
        <div>
          <h2 className="font-heading text-4xl font-bold leading-tight">Bikin Video Jualan.<br />Semudah Upload Foto.</h2>
          <p className="mt-4 text-blue-100 max-w-sm">Masuk untuk membuat video avatar AI dari foto produk Anda.</p>
        </div>
        <p className="text-xs text-blue-200">© Mas Tofa AI</p>
      </div>

      <div className="flex items-center justify-center p-6">
        <form onSubmit={handleSubmit} className="w-full max-w-sm space-y-6" data-testid="login-form">
          <div>
            <h1 className="font-heading text-3xl font-bold text-slate-900">Masuk</h1>
            <p className="mt-1 text-slate-500">Selamat datang kembali.</p>
          </div>
          <div className="space-y-2">
            <Label htmlFor="email">Email</Label>
            <Input id="email" type="email" data-testid="login-email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="nama@email.com" required />
          </div>
          <div className="space-y-2">
            <Label htmlFor="password">Password</Label>
            <Input id="password" type="password" data-testid="login-password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="••••••••" required />
          </div>
          <Button type="submit" data-testid="login-submit" disabled={loading} className="w-full bg-blue-600 hover:bg-blue-700 text-white active:scale-95 transition-transform">
            {loading && <Loader2 className="h-4 w-4 mr-2 animate-spin" />}
            Masuk
          </Button>
          <p className="text-sm text-slate-500 text-center">
            Belum punya akun?{" "}
            <Link to="/daftar" data-testid="go-register" className="font-medium text-blue-600 hover:underline">Daftar</Link>
          </p>
        </form>
      </div>
    </div>
  );
}
